import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { set, get, cloneDeep } from 'lodash';

import { Filter, Main } from 'Containers/';
import { PROVISION_2_BASE_RATES_SETUP_FORM_NAME } from 'Common/FormEnum';
import { getFiscalYear } from 'Common/GeneralHelper';
import { formatToCash } from 'Common/FormHelper';
import { Provision2BaseRatesEnum as Fields } from 'Common/FieldEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { submitForm } from 'State/forms/actions';
import * as SiteSelectors from 'State/sites/selectors';

import * as Selector from './state/provision2BaseRatesSetup/selectors';
import { Provision2BaseRatesForm } from './component/Provision2BaseRatesSetupForm';
import {
  updateLunchGridData,
  updateBreakfastGridData,
  updateSite,
  updateFiscalYear,
  updateOtherFiscalYear,
  writeBaseRatesChanges,
  setSaveSuccessful,
  setToggle,
  updateOtherFiscalYears,
} from './state/provision2BaseRatesSetup/actions';

class Provision2BaseRatesSetupContainer extends Component {
  constructor(props) {
    super(props);
    this.initialValues = this.createInitialValues();
  }
  getMainProps = () => {
    const { loading, siteId } = this.props;
    return {
      toolbox: {
        formName: PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: loading,
          onClick: this.handleSaveClick,
          disabled: siteId === null,
        },
        shown: true,
      },
    };
  };

  createInitialValues = () => {
    const { gridDataBreakfast, gridDataLunch } = this.props;
    const initialValues = {};

    gridDataLunch.forEach((x) => {
      set(initialValues, `${x.Month}FreeLunch`, formatToCash(x.Free));
      set(initialValues, `${x.Month}ReducedLunch`, formatToCash(x.Reduced));
      set(initialValues, `${x.Month}PaidLunch`, formatToCash(x.Paid));
      set(initialValues, `${x.Month}TotalLunch`, formatToCash(x.Total));
    });

    gridDataBreakfast.forEach((x) => {
      set(initialValues, `${x.Month}FreeBreakfast`, formatToCash(x.Free));
      set(initialValues, `${x.Month}ReducedBreakfast`, formatToCash(x.Reduced));
      set(initialValues, `${x.Month}PaidBreakfast`, formatToCash(x.Paid));
      set(initialValues, `${x.Month}TotalBreakfast`, formatToCash(x.Total));
    });

    return initialValues;
  };

  handleSaveClick = () => {
    const { gridDataBreakfast, gridDataLunch } = this.props;

    this.props.submitForm(PROVISION_2_BASE_RATES_SETUP_FORM_NAME);
    for (let i = 0; i < gridDataBreakfast.length; i++) {
      if (
        (gridDataBreakfast[i].Total !== 100 &&
          gridDataBreakfast[i].Total !== 0) ||
        (gridDataLunch[i].Total !== 100 && gridDataLunch[i].Total !== 0)
      ) {
        createToast(
          toastType.error,
          'Error',
          'Totals for each month must equal 0% or 100%'
        );
        break;
      }
    }
  };

  handleSiteChange = (newSite) => {
    const { updateSite } = this.props;
    updateSite(newSite);
  };

  updateFields = (gridDataLunch, gridDataBreakfast) => {
    const { change } = this.props;

    gridDataLunch.forEach((x) => {
      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}FreeLunch`,
        formatToCash(x.Free)
      );

      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}ReducedLunch`,
        formatToCash(x.Reduced)
      );

      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}PaidLunch`,
        formatToCash(x.Paid)
      );

      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}TotalLunch`,
        formatToCash(x.Total)
      );
    });
    gridDataBreakfast.forEach((x) => {
      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}FreeBreakfast`,
        formatToCash(x.Free)
      );

      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}ReducedBreakfast`,
        formatToCash(x.Reduced)
      );

      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}PaidBreakfast`,
        formatToCash(x.Paid)
      );

      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        `${x.Month}TotalBreakfast`,
        formatToCash(x.Total)
      );
    });
  };

  updateTotalField = (fieldName, total) => {
    const { change } = this.props;
    change(PROVISION_2_BASE_RATES_SETUP_FORM_NAME, fieldName, total);
  };

  componentDidUpdate(prevProps) {
    const {
      saveSuccessful,
      setSaveSuccessful,
      siteData,
      fiscalYear,
      siteId,
      change,
    } = this.props;

    if (
      prevProps.saveSuccessful !== saveSuccessful &&
      saveSuccessful === true
    ) {
      createToast(
        toastType.success,
        'Success',
        'Base Rates Saved Successfully'
      );
      setSaveSuccessful(false);
    }

    if (!prevProps.siteData && !!siteData) {
      this.handleFiscalYearChange(null, fiscalYear);
      change(
        PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
        Fields.FiscalYear,
        fiscalYear
      );
    }

    if (prevProps.siteData) {
      if (prevProps.siteId !== siteId) {
        const currentFiscalYear = getFiscalYear(new Date());
        this.handleFiscalYearChange(null, currentFiscalYear);
        change(
          PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
          Fields.FiscalYear,
          currentFiscalYear
        );
      }
    }
  }

  handleSetRatesClick = () => {
    const {
      siteData,
      updateLunchGridData,
      updateBreakfastGridData,
      otherFiscalYear,
    } = this.props;

    const index = siteData.Years.findIndex(
      (x) => x.FiscalYear === otherFiscalYear
    );

    if (index !== -1) {
      updateBreakfastGridData(get(siteData.Years[index], `Breakfast`));
      updateLunchGridData(get(siteData.Years[index], `Lunch`));

      this.updateFields(
        get(siteData.Years[index], `Lunch`),
        get(siteData.Years[index], `Breakfast`)
      );
    }
  };

  handleResetRatesClick = () => {
    const {
      siteData,
      updateLunchGridData,
      updateBreakfastGridData,
      fiscalYear,
    } = this.props;

    const index = siteData.Years.findIndex((x) => x.FiscalYear === fiscalYear);

    if (index !== -1) {
      updateBreakfastGridData(get(siteData.Years[index], `Breakfast`));

      updateLunchGridData(get(siteData.Years[index], `Lunch`));

      this.updateFields(
        get(siteData.Years[index], `Lunch`),
        get(siteData.Years[index], `Breakfast`)
      );
    }
  };

  handleSubmit = () => {
    const {
      fiscalYear,
      siteId,
      gridDataBreakfast,
      gridDataLunch,
      writeBaseRatesChanges,
    } = this.props;

    writeBaseRatesChanges({
      FiscalYear: fiscalYear,
      SiteId: siteId,
      Breakfast: gridDataBreakfast,
      Lunch: gridDataLunch,
    });
  };

  buildFiscalYears = (otherFiscalYears = []) => {
    const { fiscalYears } = this.props;
    if (otherFiscalYears.length > 0) {
      return otherFiscalYears.map((element, index) => {
        return {
          key: index,
          value: element,
          text: element.toString(),
        };
      });
    } else if (fiscalYears.length > 0) {
      return fiscalYears.map((element, index) => {
        return {
          key: index,
          value: element,
          text: element.toString(),
        };
      });
    } else {
      return [];
    }
  };

  handleFiscalYearChange = (e, fiscalYear) => {
    const {
      siteData,
      fiscalYears,
      updateLunchGridData,
      updateBreakfastGridData,
      updateFiscalYear,
      updateOtherFiscalYears,
    } = this.props;

    const index = siteData.Years.findIndex((x) => x.FiscalYear === fiscalYear);

    if (index !== -1) {
      updateBreakfastGridData(get(siteData.Years[index], `Breakfast`));
      updateLunchGridData(get(siteData.Years[index], `Lunch`));
      updateFiscalYear(fiscalYear);

      const otherFiscalYears = cloneDeep(fiscalYears);
      otherFiscalYears.splice(fiscalYears.indexOf(fiscalYear), 1);
      updateOtherFiscalYears(this.buildFiscalYears(otherFiscalYears));

      this.updateFields(
        get(siteData.Years[index], `Lunch`),
        get(siteData.Years[index], `Breakfast`)
      );
    }
  };

  render() {
    const {
      loading,
      gridDataBreakfast,
      gridDataLunch,
      siteId,
      change,
      dispatch,
      updateBreakfastGridData,
      updateLunchGridData,
      fiscalYear,
      otherFiscalYear,
      showUseAnotherFiscalYear,
      setToggle,
      updateOtherFiscalYear,
      otherFiscalYears,
      alternateProvisionTypeId,
    } = this.props;

    return (
      <Fragment>
        <Filter title={'Provision 2 Base Rates Setup'} />
        <Main {...this.getMainProps()}>
          <Provision2BaseRatesForm
            onSubmit={this.handleSubmit}
            gridDataLunch={gridDataLunch}
            gridDataBreakfast={gridDataBreakfast}
            initialValues={this.initialValues}
            change={change}
            dispatch={dispatch}
            updateLunchGridData={updateLunchGridData}
            updateBreakfastGridData={updateBreakfastGridData}
            siteId={siteId}
            handleSiteChange={this.handleSiteChange}
            fiscalYears={this.buildFiscalYears()}
            fiscalYear={fiscalYear}
            handleFiscalYearChange={this.handleFiscalYearChange}
            handleSetRatesClick={this.handleSetRatesClick}
            handleResetRatesClick={this.handleResetRatesClick}
            otherFiscalYear={otherFiscalYear}
            updateTotalField={this.updateTotalField}
            showUseAnotherFiscalYear={showUseAnotherFiscalYear}
            setToggle={setToggle}
            updateOtherFiscalYear={updateOtherFiscalYear}
            otherFiscalYears={otherFiscalYears}
            loading={loading}
            alternateProvisionTypeId={alternateProvisionTypeId}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const siteId = Selector.getSiteId(state);

  return {
    loading: Selector.getLoading(state),
    gridDataLunch: Selector.getGridDataLunch(state),
    gridDataBreakfast: Selector.getGridDataBreakfast(state),
    siteId,
    fiscalYears: Selector.getFiscalYears(state),
    siteData: Selector.getSiteData(state),
    fiscalYear: Selector.getFiscalYear(state),
    saveSuccessful: Selector.getSaveSuccessful(state),
    otherFiscalYear: Selector.getOtherFiscalYear(state),
    showUseAnotherFiscalYear: Selector.getShowUseAnotherFiscalYear(state),
    otherFiscalYears: Selector.getOtherFiscalYears(state),
    alternateProvisionTypeId: SiteSelectors.getAlternateProvisionTypeId(
      state,
      siteId
    ),
  };
};

const mapDispatchToProps = {
  change,
  updateLunchGridData,
  updateBreakfastGridData,
  submitForm,
  updateSite,
  updateFiscalYear,
  updateOtherFiscalYear,
  writeBaseRatesChanges,
  setSaveSuccessful,
  setToggle,
  updateOtherFiscalYears,
};

export const Provision2BaseRatesSetup = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Provision2BaseRatesSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/Provision2BaseRatesSetup.js